import Overlay from "../Overlay";
import ConfirmationModal from "../ConfirmationModal";
import ActionButton from '../ActionButton'
export default {
  name: 'eMandateSuccess',
  components: {
    Overlay,
    ConfirmationModal,
    ActionButton
  },
  data () {
    return {
      message: {
        value: '<h4>Congratulations!</h4> You have successfully linked your bank account. ',
        type: 'success',
        fieldName: 'kyc-emandate',
        actions: [
          {
            title: "Go to Dashboard",
            method: () => this.goToDashboard(),
            isPrimary: true
          },
        ]

      },
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "EMANDATE_REGISTERED",
      propertyName: "RESULT",
      propertyValue: "SUCCESS"
    });
  },
  methods: {
    goToDashboard () {
      this.$router.push({ name: 'Dashboard' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/eMandateSuccess/component.js